export default "__VITE_ASSET__WYrw0y5N__"